export interface Orders {
    orders: Order[];
    summary: Summary;
    pagination?: Pagination;
  }

export interface Pagination {
    page: number;
    size: number;
    total_items: number;
    total_pages: number;
}

export enum PaymentProvider {
    CONTRA_ENTREGA = "contra_entrega",
    MERCADO_PAGO = "mercadopago",
    STRIPE = "stripe",
    CONFIO = "confio",
}
  
export interface BenefitPurchase {
    label: string;
    name: string;
    price: number;
}

export interface Order {
    id: number;
    hash_id: string;
    priority: string;
    created_at: string;
    logistic_state: string;
    payment_method?: "cod" | "online" | string;
    payment_provider?: PaymentProvider;
    payment_state: string;
    total_value: number;
    total_value_with_discount: number;
    customer_name: string;
    customer_las_name: string;
    customer_prefix_phone: string;
    customer_phone: string;
    customer_email: string;
    customer_address: string;
    total_units: number;
    channel: string;
    dropi_state?: DropiState;
    dropi_observed_status?: string | null;
    dropi_order_status?: string | null;
    dropi_url?: string;
    shopify_integration_state?: ShopifyState;
    dropi_integration_error?: string;
    shopify_integration_error?: string;
    benefit_purchases?: BenefitPurchase[];
}

export enum DropiState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
    WAITING_PAYMENT = "WAITING_PAYMENT",
}

export enum ShopifyState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}
  
export interface Summary {
    total_buyers: number;
    total_units: number | string;
    total_value: number | string;
    total_value_with_discount: number | string;
  }
